import {gql} from "@apollo/client";

export const reprocessBridgeStatusKyb = gql`
    mutation ReprocessBridgeForBusiness($customerId: String!) {
        reprocessBridgeForCustomer_Admin(customerId: $customerId)
    }
`